import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

export const init = (config: any) => {

    if (config && config.pollId) {
        ReactDOM.render(
            <React.StrictMode>
                <App config={config} />
            </React.StrictMode>,
            document.getElementById('root')
        );
    } else {
        ReactDOM.render(
            <React.StrictMode>
                <div>Configuration Error. You need to add a poll identification as well</div>
            </React.StrictMode>,
            document.getElementById('root')
        );
    }


}


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
